// i18n Translations – Deutsch / English
export const translations = {
  de: {
    nav: {
      home: "Start",
      about: "Über mich",
      lomi: "Lomi Lomi Nui",
      tibeter: "6 Tibeter",
      koerperbalance: "Körperbalance",
      contact: "Kontakt",
      book: "Termin buchen",
    },
    hero: {
      kicker: "Tempelritual mit Ölen · Hawaiianische Körperarbeit",
      title: "Lotus Sutra",
      subtitle: "Erwecke deine innere Kraft durch hawaiianische Körperarbeit und tibetische Weisheit",
      cta: "Termin buchen",
      cta2: "Mehr erfahren",
    },
    about: {
      label: "Über mich",
      name: "Michael Moser",
      role: "Humanenergetiker",
      p1: "Mit tiefer Hingabe und jahrelanger Erfahrung begleite ich Menschen auf ihrem Weg zu innerer Balance und ganzheitlichem Wohlbefinden. Meine Arbeit ist geprägt von Achtsamkeit, Präsenz und dem tiefen Respekt vor der Lebensenergie jedes Einzelnen.",
      p2: "Die Verbindung von hawaiianischer Lomi Lomi Tradition und tibetischer Weisheitslehre ermöglicht es mir, einen Raum zu schaffen, in dem energetische Ausgewogenheit und Entspannung auf allen Ebenen erfahrbar werden.",
      p3: "Jede Begleitung ist ein achtsames Ritual – eine Einladung, alte Anspannungen loszulassen und in die eigene Kraft zurückzukehren.",
    },
    offer: {
      label: "Mein Angebot",
      lomiTitle: "Lomi Lomi Nui",
      lomiDesc: "Tempelritual mit Ölen aus Hawaii",
      tibTitle: "6 Tibeter",
      tibDesc: "Körperbalance",
      kbTitle: "Körperbalance",
      kbDesc: "Harmonie von Körper, Geist und Seele",
    },
    lomi: {
      label: "Tempelritual mit Ölen",
      title: "Lomi Lomi Nui",
      sub: "Eine Mischung aus Ritual, Körperarbeit und Tanz",
      p1: "Lomi Lomi Nui ist eine Mischung aus Ritual, Körperarbeit und Tanz, die früher auf Hawaii im Tempel ausgeübt wurde. Es ist kein gewöhnliches Handwerk – es ist ein Tempelritual mit Ölen.",
      p2: "Die Körperarbeit ist ein besonderes Erlebnis und wirkt wie ein Segen. Sie führt in erlebbare Dimensionen, die in unserer westlichen Welt rar geworden sind. Das Ritual unterstützt das Loslassen alter Anspannungen und fördert auf wunderbare Weise das innere Wohlbefinden.",
      p3: "Es werden energetische Techniken aus der hawaiianischen Elementenlehre sowie sanfte Bewegungs- und Lockerungsübungen verwendet. Die geistigen Prinzipien der Huna-Philosophie bilden die Grundlage.",
      p4: "Lomi ist ein Ritual. Ziel ist es, die vorhandene Lebensenergie zu fördern und zu manifestieren.",
    },
    tibeter: {
      label: "Himalaya Tradition",
      title: "Die 6 Tibeter",
      sub: "Uralte Rituale aus dem Himalaya für ewige Jugend und Vitalität",
      p1: "Die 6 Tibeter sind eine Serie kraftvoller, yoga-ähnlicher Übungen, die seit Jahrhunderten in tibetischen Klöstern praktiziert werden. Diese energetischen Rituale aktivieren die sieben Hauptchakren und bringen den Energiefluss im Körper wieder in Balance.",
      p2: "Durch die tägliche Praxis der 6 Tibeter wird der Körper verjüngt, der Geist geklärt und die Lebensenergie erhöht. Die Übungen sind einfach zu erlernen und können in nur 15–20 Minuten täglich durchgeführt werden.",
      effectsTitle: "Wirkung der 6 Tibeter",
      effects: [
        "Steigerung der körperlichen und geistigen Energie",
        "Verbesserung der Beweglichkeit und Körperhaltung",
        "Harmonisierung des Hormon- und Nervensystems",
        "Tiefe innere Ruhe und mentale Klarheit",
        "Förderung der körpereigenen Lebenskräfte",
      ],
    },
    benefits: {
      label: "Wirkung & Vorteile",
      items: [
        { t: "Stress lösen", d: "Tiefe Entspannung und Lösung von körperlichen und emotionalen Blockaden." },
        { t: "Innere Ruhe", d: "Zurück zu deiner Mitte – Achtsamkeit und Präsenz im Hier und Jetzt." },
        { t: "Emotionale Balance", d: "Sanftes Loslassen alter Belastungen und Rückkehr zu innerer Harmonie." },
        { t: "Balance", d: "Harmonisierung von Körper, Geist und Seele." },
      ],
    },
    gallery: {
      label: "Impressionen",
      sub: "Einblicke in meine Arbeit",
    },
    quote: "Der Schlüssel zum Erwachen ist, deine ganze Aufmerksamkeit und Energie in das Hier und Jetzt zu bringen.",
    quoteBy: "Adyashanti",
    contact: {
      label: "Kontakt",
      sub: "Ich freue mich auf deine Nachricht",
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      social: "Social Media",
      send: "Nachricht senden",
      namePh: "Dein Name",
      emailPh: "Deine E-Mail",
      msgPh: "Deine Nachricht",
      sent: "Vielen Dank! Deine Nachricht wurde gesendet.",
    },
    footer: {
      tagline: "Hawaiianische Körperarbeit · Tibetische Weisheit",
      rights: "Alle Rechte vorbehalten.",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
    },
    cookies: {
      title: "Cookie-Hinweis",
      text: "Diese Website verwendet nur technisch notwendige Cookies, die für den sicheren Betrieb erforderlich sind. Es werden keine Marketing- oder Tracking-Cookies gesetzt. Mehr Informationen findest du in unserer",
      linkText: "Datenschutzerklärung",
      accept: "Verstanden",
      decline: "Ablehnen",
    },
    impressum: {
      title: "Impressum",
      sub: "Angaben gemäß §5 ECG / §25 MedienG",
      ownerLabel: "Medieninhaber & Diensteanbieter",
      contactLabel: "Kontakt",
      profLabel: "Berufsbezeichnung & berufsrechtliche Regelungen",
      profValue: "Humanenergetiker / Gewerbliche Massage",
      profCountry: "Verliehen in Österreich",
      mittLabel: "Streitbeilegung",
      mittText: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
      copyLabel: "Urheberrecht",
      copyText: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
      disclaimerLabel: "Haftungsausschluss",
      disclaimerText: "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. Die auf dieser Website angebotenen Leistungen ersetzen keine ärztliche Diagnose oder Behandlung.",
    },
    datenschutz: {
      title: "Datenschutz",
      sub: "Informationen zur Verarbeitung personenbezogener Daten (DSGVO)",
      sections: [
        {
          h: "1. Verantwortlicher",
          p: "Verantwortlich für die Datenverarbeitung auf dieser Website ist Michael Moser, Forstweg 20, 9710 Feistritz an der Drau, Österreich. E-Mail: michael@lotussutra.at, Telefon: +43 0681 10 70 58 71.",
        },
        {
          h: "2. Erhebung und Speicherung personenbezogener Daten",
          p: "Wenn du uns per Kontaktformular oder E-Mail Anfragen zukommen lässt, werden deine Angaben inklusive der von dir dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und f DSGVO.",
        },
        {
          h: "3. Server-Log-Dateien",
          p: "Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien (Browsertyp, Betriebssystem, Referrer URL, Hostname, Uhrzeit, IP-Adresse). Diese Daten werden nicht mit anderen Datenquellen zusammengeführt und dienen ausschließlich der Sicherheit und dem stabilen Betrieb der Website.",
        },
        {
          h: "4. Cookies",
          p: "Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den sicheren Betrieb der Seite erforderlich sind. Marketing- oder Tracking-Cookies werden nicht gesetzt.",
        },
        {
          h: "5. Social Media",
          p: "Auf dieser Website verweisen Links zu unseren Profilen bei Instagram und Facebook. Beim Aufruf dieser Links verlässt du unsere Website; die jeweiligen Plattformbetreiber verarbeiten deine Daten nach eigenen Richtlinien.",
        },
        {
          h: "6. Deine Rechte",
          p: "Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Wende dich dazu bitte an die oben genannte E-Mail-Adresse. Zudem steht dir ein Beschwerderecht bei der Österreichischen Datenschutzbehörde zu.",
        },
        {
          h: "7. SSL-Verschlüsselung",
          p: "Diese Seite nutzt aus Gründen der Sicherheit eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennst du am „https://“ in der Adresszeile deines Browsers.",
        },
      ],
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      lomi: "Lomi Lomi Nui",
      tibeter: "6 Tibetans",
      koerperbalance: "Body Balance",
      contact: "Contact",
      book: "Book Session",
    },
    hero: {
      kicker: "Temple Ritual with Oils · Hawaiian Bodywork",
      title: "Lotus Sutra",
      subtitle: "Awaken your inner strength through Hawaiian bodywork and Tibetan wisdom",
      cta: "Book a Session",
      cta2: "Learn More",
    },
    about: {
      label: "About",
      name: "Michael Moser",
      role: "Human Energetic Practitioner",
      p1: "With deep dedication and years of experience, I guide people on their path to inner balance and holistic wellbeing. My work is shaped by mindfulness, presence, and a profound respect for the life energy of every individual.",
      p2: "The union of the Hawaiian Lomi Lomi tradition and Tibetan wisdom allows me to create a space in which energetic balance and deep relaxation can unfold on every level.",
      p3: "Each session is a mindful ritual – an invitation to release old tensions and return to your own strength.",
    },
    offer: {
      label: "My Offering",
      lomiTitle: "Lomi Lomi Nui",
      lomiDesc: "Hawaiian temple ritual with oils",
      tibTitle: "6 Tibetans",
      tibDesc: "Body Balance",
      kbTitle: "Body Balance",
      kbDesc: "Harmony of body, mind and soul",
    },
    lomi: {
      label: "Temple Ritual with Oils",
      title: "Lomi Lomi Nui",
      sub: "A blend of ritual, bodywork and dance",
      p1: "Lomi Lomi Nui is a blend of ritual, bodywork and dance that was once practiced in the temples of Hawaii. It is no ordinary craft – it is a temple ritual with oils.",
      p2: "The work is a profound experience and feels like a blessing. It opens dimensions that have become rare in our western world. The ritual supports the release of old tensions and gently fosters a deep sense of inner wellbeing.",
      p3: "Energetic techniques from the Hawaiian elemental teachings are woven together with gentle movement and loosening exercises. The spiritual principles of the Huna philosophy form the foundation.",
      p4: "Lomi is a ritual. Its aim is to awaken and manifest the life force already within you.",
    },
    tibeter: {
      label: "Himalayan Tradition",
      title: "The 6 Tibetans",
      sub: "Ancient Himalayan rituals for eternal youth and vitality",
      p1: "The 6 Tibetans are a sequence of powerful, yoga-like exercises practiced for centuries in Tibetan monasteries. These energetic rituals activate the seven main chakras and restore the flow of energy in the body.",
      p2: "Through daily practice, the body is rejuvenated, the mind clarified and life energy heightened. The exercises are easy to learn and take only 15–20 minutes a day.",
      effectsTitle: "Benefits of the 6 Tibetans",
      effects: [
        "Increased physical and mental energy",
        "Improved mobility and posture",
        "Balanced hormonal and nervous system",
        "Deep inner calm and mental clarity",
        "Support of the body's own life energy",
      ],
    },
    benefits: {
      label: "Effects & Benefits",
      items: [
        { t: "Release Stress", d: "Deep relaxation and release of physical and emotional blockages." },
        { t: "Inner Calm", d: "Return to your centre – mindfulness and presence in the here and now." },
        { t: "Emotional Balance", d: "Gently let go of old burdens and return to inner harmony." },
        { t: "Balance", d: "Harmonising body, mind and soul." },
      ],
    },
    gallery: {
      label: "Impressions",
      sub: "Insights into my work",
    },
    quote: "The key to awakening is to get all of your attention and energy into right here and right now.",
    quoteBy: "Adyashanti",
    contact: {
      label: "Contact",
      sub: "I look forward to your message",
      phone: "Phone",
      email: "Email",
      address: "Address",
      social: "Social Media",
      send: "Send Message",
      namePh: "Your name",
      emailPh: "Your email",
      msgPh: "Your message",
      sent: "Thank you! Your message has been sent.",
    },
    footer: {
      tagline: "Hawaiian Bodywork · Tibetan Wisdom",
      rights: "All rights reserved.",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
    },
    cookies: {
      title: "Cookie notice",
      text: "This website only uses technically necessary cookies required for secure operation. No marketing or tracking cookies are set. More information is available in our",
      linkText: "privacy policy",
      accept: "Understood",
      decline: "Decline",
    },
    impressum: {
      title: "Imprint",
      sub: "Information pursuant to §5 ECG / §25 MedienG (Austria)",
      ownerLabel: "Owner & Service Provider",
      contactLabel: "Contact",
      profLabel: "Professional Title & Regulations",
      profValue: "Human Energetic Practitioner / Commercial Massage",
      profCountry: "Awarded in Austria",
      mittLabel: "Dispute Resolution",
      mittText: "The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr. We are neither obliged nor willing to take part in dispute resolution proceedings before a consumer arbitration board.",
      copyLabel: "Copyright",
      copyText: "The content and works on these pages created by the site operators are subject to Austrian copyright law. Duplication, processing, distribution and any form of commercialisation beyond the limits of copyright law require the written consent of the respective author or creator.",
      disclaimerLabel: "Disclaimer",
      disclaimerText: "Despite careful content control, we assume no liability for the content of external links. The operators of the linked sites are solely responsible for their content. The services offered on this website do not replace medical diagnosis or treatment.",
    },
    datenschutz: {
      title: "Privacy Policy",
      sub: "Information on the processing of personal data (GDPR)",
      sections: [
        {
          h: "1. Controller",
          p: "The controller for data processing on this website is Michael Moser, Forstweg 20, 9710 Feistritz an der Drau, Austria. Email: michael@lotussutra.at, Phone: +43 0681 10 70 58 71.",
        },
        {
          h: "2. Collection and Storage of Personal Data",
          p: "When you contact us via the contact form or by email, your details including the contact data you provide are stored for the purpose of handling the request and in the event of follow-up questions. Legal basis is Art. 6 (1) (b) and (f) GDPR.",
        },
        {
          h: "3. Server Log Files",
          p: "The provider of the site automatically collects and stores information in so-called server log files (browser type, operating system, referrer URL, hostname, time, IP address). This data is not merged with other data sources and is used exclusively for the security and stable operation of the website.",
        },
        {
          h: "4. Cookies",
          p: "This website uses only technically necessary cookies required for the secure operation of the site. No marketing or tracking cookies are set.",
        },
        {
          h: "5. Social Media",
          p: "This website links to our profiles on Instagram and Facebook. When you follow those links, you leave our website; the respective platform operators process your data according to their own guidelines.",
        },
        {
          h: "6. Your Rights",
          p: "You have the right to access, rectification, erasure, restriction of processing, data portability and objection at any time. Please contact the email address above. You also have the right to lodge a complaint with the Austrian Data Protection Authority.",
        },
        {
          h: "7. SSL Encryption",
          p: "For security reasons this site uses SSL/TLS encryption. An encrypted connection is recognisable by the “https://” in the address bar of your browser.",
        },
      ],
    },
  },
};
